import { translateFormatter } from '@/domains/core/localization/translate';
export const numberOfReview = translateFormatter<{
  totalRating: number;
}>("from {totalRating, plural, =1 {# review} other {# reviews}}", undefined, undefined, "en");